// `Symbol.split` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.split
require('../internals/define-well-known-symbol')('split');